const initialStateForUserOrders = {
  fetching: false,
  fetched: false,
  items: [],
  isTotal: true,
  error: null,
  pageSize:10,
  paginationPage: 1,
  embedded : 0,
}

export const orderLineReducer = (state = initialStateForUserOrders, action) => {
  switch (action.type) {
    case 'FETCH_ORDER_LINES_PENDING': {
      return {...state, fetched: false, fetching: true};
      break;
    }
    case 'FETCH_ORDER_LINES_FULFILLED': {
      const data = action.payload
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data
      };
      break;
    }
    case 'FETCH_ORDER_LINES_REJECTED': {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          }
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [],
        error
      };
      break;
    }

    case 'SET_EMBEDDED': {
      return {...state, embedded: action.payload};
      break;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/index/orderLine.js